import { render } from "./PostBody.vue?vue&type=template&id=3e8e00a6&scoped=true"
import script from "./PostBody.vue?vue&type=script&lang=js"
export * from "./PostBody.vue?vue&type=script&lang=js"

import "./post-body.scss?vue&type=style&index=0&id=3e8e00a6&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8e00a6"]])

export default __exports__